
import Vue from 'vue'
import createServiceCategory from '@/connectors/services/create-service-category'
import deleteServiceCategory from '@/connectors/services/delete-service-category'
import {
  updateServiceCategory,
  createService,
  deleteService,
  getServiceCategories,
  updateService
} from '@/connectors/services'
import Loader from '@/components/Loader.vue'
import ServiceCategoryPopup from '@/components/popup/ServiceCategoryPopup.vue'
import ServicePopup from '@/components/popup/ServicePopup.vue'
import ServicesComponent from '@/components/ServicesComponent.vue'
import { ICreateService, IServiceCategory } from '@/types/services'
import { ModalIds } from '@/components/popup/modal-ids'

export default Vue.extend({
  name: 'Services',
  components: { ServicesComponent, ServicePopup, ServiceCategoryPopup, Loader },
  data () {
    return {
      ModalIds,
      loader: false,
      editing: false,
      tree: [] as IServiceCategory[],
      oneCategory: {} as IServiceCategory,
      oneService: {} as Partial<ICreateService>,
      isDisabled: false
    }
  },
  computed: {
    idSelectedOrganization (): number {
      if (this.$store.state.profile.currentOrganization) {
        return this.$store.state.profile.currentOrganization?.id
      }
      return 0
    }
  },
  watch: {
    idSelectedOrganization () {
      this.pullTree()
    }
  },
  mounted () {
    this.pullTree()
  },
  methods: {
    // Открываем модалку для новой категории
    prepareCreateCategory (item) {
      this.editing = false
      this.oneCategory = { ...item }
      this.oneCategory.name = ''
    },
    // Открываем модалку для редактирования категории
    prepareUpdateCategory (category) {
      this.editing = true
      this.oneCategory = { ...category }
    },
    // Открываем модалку для новой услуги
    prepareCreateService (category) {
      this.editing = false
      this.oneCategory = { ...category }
      this.oneService = {}
    },
    // Открываем модалку для редактирования услуги
    prepareUpdateService (service) {
      this.editing = true
      this.oneService = { ...service }
    },
    createDirectory (category) {
      const formData = {
        moid: this.idSelectedOrganization,
        name: category.name,
        parent_id: category.id
      }
      this.isDisabled = true
      createServiceCategory(formData)
        .then(() => {
          this.pullTree()
          this.isDisabled = false
          // @ts-ignore
          this.$showSuccessToast('Каталог услуг создан успешно')
        }).catch(e => {
          console.error(e.response)
          this.isDisabled = false
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    createService (service) {
      this.isDisabled = true
      service.moid = this.idSelectedOrganization
      service.parentId = this.oneCategory.id
      createService(service)
        .then(() => {
          this.pullTree()
          this.isDisabled = false
          // @ts-ignore
          this.$showSuccessToast('Услуга создана успешно')
        }).catch(e => {
          console.error(e.response)
          this.isDisabled = false
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    updateService (service) {
      this.isDisabled = true
      service.moid = this.idSelectedOrganization
      updateService(service.id, service)
        .then(() => {
          this.pullTree()
          this.isDisabled = false
          // @ts-ignore
          this.$showSuccessToast('Услуга обновлена успешно')
        }).catch(e => {
          this.isDisabled = false
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    updateNameDirectory (category) {
      category.moid = this.idSelectedOrganization
      const formData = {
        moid: this.idSelectedOrganization,
        name: category.name
      }
      this.isDisabled = true
      updateServiceCategory(category.id, formData)
        .then(() => {
          this.pullTree()
          this.isDisabled = false
          // @ts-ignore
          this.$showSuccessToast('Каталог услуг обновлен успешно')
        }).catch(e => {
          console.error(e.response)
          this.isDisabled = false
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    deleteDirectory (id) {
      this.isDisabled = true
      deleteServiceCategory(id, this.idSelectedOrganization)
        .then(() => {
          this.pullTree()
          this.isDisabled = false
          // @ts-ignore
          this.$showSuccessToast('Каталог услуг удален успешно')
        }).catch(e => {
          console.error(e.response)
          this.isDisabled = false
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    deleteService (service) {
      this.isDisabled = true
      deleteService(service.id, this.idSelectedOrganization)
        .then(() => {
          this.pullTree()
          this.isDisabled = false
          // @ts-ignore
          this.$showSuccessToast('Услуга удалена успешно')
        }).catch(e => {
          console.error(e.response)
          this.isDisabled = false
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    },
    pullTree () {
      this.loader = true
      if (!this.idSelectedOrganization) {
        return
      }
      this.loader = true
      getServiceCategories(this.idSelectedOrganization)
        .then((res: any) => {
          this.tree = res
          this.loader = false
        }).catch(e => {
          this.loader = false
          console.error(e.response)
          // @ts-ignore
          this.$showErrorToast(e.response.data.message)
        })
    }
  }
})
